import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type {
  APIResponse,
  ContactPhoneCall,
  ContactPhoneCallCreateInput,
  ContactPhoneCallUpdateInput,
} from "@/lib/types";

const phoneCallsRoute = "firms/v2/communications/phone-calls";

export type RetrieveContactPhoneCallsParams = {
  contactId?: string;
  cursor?: string;
  limit?: number;
  signal?: AbortSignal;
};

export const retrieveContactPhoneCallsV2 = ({
  contactId,
  cursor,
  limit = 50,
  signal,
}: RetrieveContactPhoneCallsParams = {}) =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<ContactPhoneCall[]>>(phoneCallsRoute, {
      params: { contactId, cursor, limit },
      signal,
    })
    .then((response) => response.data);

export const retrieveContactPhoneCallV2 = (
  phoneCallId: string,
  signal?: AbortSignal,
) =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<ContactPhoneCall>>(`${phoneCallsRoute}/${phoneCallId}`, {
      signal,
    })
    .then((response) => response.data);

export const createContactPhoneCallV2 = (input: ContactPhoneCallCreateInput) =>
  authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactPhoneCall>>(phoneCallsRoute, input)
    .then((response) => response.data);

export type UpdateContactPhoneCallParams = ContactPhoneCallUpdateInput & {
  id: string;
};

export const updateContactPhoneCallV2 = ({
  id,
  ...input
}: UpdateContactPhoneCallParams) =>
  authenticatedFastApiAxiosInstance
    .patch<APIResponse<ContactPhoneCall>>(`${phoneCallsRoute}/${id}`, input)
    .then((response) => response.data);

export const deleteContactPhoneCallV2 = ({ id }: { id: string }) =>
  authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactPhoneCall>>(`${phoneCallsRoute}/${id}`)
    .then((response) => response.data);
